import AsyncSelect from 'react-select/async';
import { get } from '../../../services/apiController';
import { debounce } from 'lodash';

const filterVendors = async (inputValue) => {
  if (!inputValue) {
    return [];
  }
  const response = await get(`/vendor-masters?query=${inputValue}`);
  if (response) {
    return response.data.rows.map((item) => ({
      label: item.name,
      value: item.id,
    }));
  }
};

// Debounce the API call to prevent excessive requests
const debouncedFilterVendors = debounce(async (inputValue, callback) => {
  const results = await filterVendors(inputValue);
  callback(results);
}, 400);

const loadOptions = (inputValue, callback) => {
  debouncedFilterVendors(inputValue, callback);
};

export default ({ onSelect }) => (
  <AsyncSelect
    cacheOptions
    loadOptions={loadOptions}
    defaultOptions
    isClearable
    placeholder="Search for a vendor"
    onChange={onSelect}
    styles={{
      control: (baseStyles, state) => ({
        ...baseStyles,
        minHeight: '58px',
        borderRadius: '0.375rem',
        borderColor: state.isFocused ? '#86b7fe' : '#dee2e6',
        boxShadow: state.isFocused ? '0 0 0 0.25rem rgba(13, 110, 253, 0.25)' : 'none',
        '&:hover': {
          borderColor: state.isFocused ? '#86b7fe' : '#dee2e6',
        },
      }),
      placeholder: (baseStyles) => ({
        ...baseStyles,
        color: '#6c757d',
      }),
      input: (baseStyles) => ({
        ...baseStyles,
        color: '#212529',
      }),
    }}
  />
);
